import PropTypes from 'prop-types';
import React from 'react';
import { TabListStyled, TabPanelStyled, TabStyled } from './index.styles';

export function TabClient(props) {
  const { headings, panels, activeTab, onTabChange } = props;

  return (
    <>
      <TabListStyled
        value={activeTab}
        onChange={onTabChange}
        variant="fullWidth"
      >
        {headings.map((heading, index) => (
          <TabStyled
            key={heading.title}
            value={index}
            label={heading.title}
            icon={heading.icon}
            iconPosition="start"
          />
        ))}
      </TabListStyled>
      {panels.map((panel) => (
        <TabPanelStyled key={panel.value} hidden={panel.value !== activeTab}>
          {panel.component}
        </TabPanelStyled>
      ))}
    </>
  );
}

TabClient.propTypes = {
  headings: PropTypes.arrayOf(PropTypes.shape({ title: PropTypes.string }))
    .isRequired,
  panels: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      component: PropTypes.element,
    })
  ).isRequired,
  activeTab: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired,
};
